// LANDING PAGE URLUTIL
const productionDomains = ['engros.ae', 'engros.ai', 'engros.app', 'engros.at', 'engros.dev', 'engros.es', 'engros.fi', 'engros.in', 'engros.io', 'engros.it', 'engros.nz', 'engros.pt', 'engros.se', 'engros.uk', 'partihandel.io', 'partihandel.se', 'partihanteraren.com', 'pifa.se'];

// `www` is not a tenant. Production returns the full host below so that a
// tenant subdomain survives into the service hosts (tenant.engros.se ->
// id.tenant.engros.se), but `www` went through the same path and produced
// id.www.partihandel.se and api.www.partihandel.se — neither name exists in
// DNS, so the login button dead-ended on "Server Not Found" and the public
// claim/delivery pages could not reach the API at all. Only the hostnames
// with a Cloud Run domain mapping resolve; a derived one never will.
// Strip it before anything else looks at the host.
const stripWww = host => host.replace(/^www\./, '');

// Base domains that are ours-but-not-production. They stay in
// productionDomains above so the endsWith match keeps working, but they must
// report `sandbox`. Mirrors SANDBOX_BASE_DOMAINS in
// application/src/utils/UrlUtil.js and SANDBOX_DOMAINS in
// pifa-api/src/config/CorsConfig.js.
const SANDBOX_BASE_DOMAINS = ['engros.dev'];

const getEnvironmentAndDomain = () => {
	const host = stripWww(window.location.host);

	if (host.includes('pifa.dev')) {
		return {environment: 'sandbox', domain: host};
	}

	if (host.includes('localhost:8080')) {
		return {environment: 'localproduction', domain: host};
	}

	if (host.includes('localhost')) {
		return {environment: 'development', domain: host};
	}

	// Check production domains using endsWith for precise matching
	const matchedDomain = productionDomains.find(domain => host.endsWith(domain));

	if (matchedDomain) {
		// Return the full host (including subdomain) for production
		return {environment: SANDBOX_BASE_DOMAINS.includes(matchedDomain) ? 'sandbox' : 'production', domain: host};
	}

	return {environment: 'development', domain: 'localhost'};
};

const {environment, domain} = getEnvironmentAndDomain();

// Partihandel's own social links (TikTok/Instagram/GitHub/X/LinkedIn in the
// footer) must only show on Pifa's own brand domains. A tenant subdomain is
// also served the landing page — getHostEnvironment in server.js routes
// eth.partihandel.se to landingpageserver — so without this gate a tenant's
// own marketing host carried Pifa's social accounts. `domain` is the full
// host here (www already stripped above), so an exact match excludes
// subdomains on its own. Mirrors showSocialIcons in login/src/UrlUtil.js,
// including the non-production exemption so developers can still see them.
const PIFA_BRAND_DOMAINS = ['pifa.se', 'engros.ai', 'partihandel.se'];
const showSocialIcons = environment !== 'production' || PIFA_BRAND_DOMAINS.includes(domain);

const getLoginUrl = () => {
	switch (environment) {
		case 'production':
		case 'sandbox':
			return `https://id.${domain}`;
		case 'localproduction':
			return 'http://id.localhost:8080';
		default:
			return 'http://localhost:2000';
	}
};

const getApiBaseUrl = () => {
	switch (environment) {
		case 'production':
		case 'sandbox':
			return `https://api.${domain}`;
		default:
			return 'http://localhost:8000';
	}
};

export {getLoginUrl, getApiBaseUrl, showSocialIcons};
